export default __webpack_public_path__ + "static/media/rightUsersProfile.d023fdb3.svg";